// extracted by mini-css-extract-plugin
export var icon = "style-module--icon--02061";
export var labelWIcon = "style-module--label-w-icon--2e35e";
export var text = "style-module--text--71075";